import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';
import { selectSettings } from '../../../store/selectors/settingsSelectors';
import { authScopeStringGetHelper } from '../../../util/helpers/authScopeHelpers';
import { JWT_TOKEN } from '../../../constants/localStorage';
import {
  getCurrentAccountCode,
  getCurrentAccountUid,
  selectNagDashboard,
} from '../../../store/selectors/accountSelectors';
import { UPGRADE_STATUS_TYPES } from '../../../constants/nagDashboardContants';

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${pxToRem(8)} 0;
`;

const DrawerIconWrapper = styled.div`
  margin-bottom: ${pxToRem(16)};
`;

const DrawerTitle = styled.h3`
  font-size: 16;
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  text-align: center;
  margin-bottom: ${pxToRem(8)};
`;

const DrawerDescription = styled.p`
  font-size: 14;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  text-align: center;
  line-height: 1.5;
`;

const DrawerFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};

  > button {
    width: 100%;
  }
`;

const VerifySellFromHomeDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { RegistrationUrlV2: registrationApi } = useSelector(selectSettings);
  const token = authScopeStringGetHelper(JWT_TOKEN);
  const accountUid = useSelector(getCurrentAccountUid);
  const accountCode = useSelector(getCurrentAccountCode);
  const nagDashboard = useSelector(selectNagDashboard);
  const isUpgradeProgress =
    nagDashboard?.UpgradeStatusType === UPGRADE_STATUS_TYPES.InProgress;

  const goToRegistrationPage = () => {
    window.location.replace(
      `${registrationApi}/choose-application?accountCode=${accountCode}&accountUid=${accountUid}&token=${token}`,
    );
  };

  const footer = (
    <DrawerFooter>
      <Button
        variant="primary"
        textTransform="none"
        onClick={goToRegistrationPage}
      >
        {isUpgradeProgress ? t('common.continue') : t('common.verifyAccount')}
      </Button>
      <Button variant="primaryOutlined" textTransform="none" onClick={onClose}>
        {t('common.doItLater')}
      </Button>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <DrawerContent>
        <DrawerIconWrapper>
          <InfoIcon width={35} height={35} />
        </DrawerIconWrapper>
        <DrawerTitle>
          {t('basicAccountRestrictions.verifyAccountSellFromHome.title')}
        </DrawerTitle>
        <DrawerDescription>
          {t('basicAccountRestrictions.verifyAccountSellFromHome.description')}
        </DrawerDescription>
      </DrawerContent>
    </BottomDrawer>
  );
};

VerifySellFromHomeDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default VerifySellFromHomeDrawer;
